<template>
    <div>
        <h1 style="text-align: center;">Infographic5 Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="imgsel" v-on:change="changeThumb()" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                <h2 style="flex: 100%; text-align: center;">Labels</h2>
                <div style="flex: 25%;box-sizing: border-box; border: 1px solid white; display: flex; flex-direction: column;" v-for="(label, li) in data.labels" :key="'LABEL' + li" :ref="'cntLabel-' + li">
                    <h3 style="text-align: center;">Label #{{li + 1}}</h3>
                    <div style="display: flex; align-items: center; text-align: center; flex-direction: column; flex: 100%;">
                        <Minimap :img="grayimg" :x="label.position.x" :y="label.position.y"></Minimap>
                        <span style="width: 100%;">
                            X: <input type="range" min="0" max="750" v-model="label.position.x" style="width: 400px;">
                            <input type="text" v-model="label.position.x" style="width: 40px;">
                        </span>
                        <span style="width: 100%;">
                            Y: <input type="range" min="0" max="550" v-model="label.position.y" style="width: 400px;">
                            <input type="text" v-model="label.position.y" style="width: 40px;">
                        </span>
                    </div>
                    <input type="text" v-model="label.label" placeholder="Label">
                    <div><label>Color:</label><input type="color" v-model="label.color"></div>
                    <button style="flex: 100%; background: red; color: white;" @click="deleteLabel(li)">Delete Label</button>
                </div>
                <button style="flex: 100%; margin: 1em;" @click="addNewLabel()">Add New Label</button>
            </div>
            <hr>
            <hr>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                <h2 style="flex: 100%; text-align: center;">Markers</h2>
                <div style="flex: 25%;box-sizing: border-box; border: 1px solid white; display: flex; flex-direction: column;" v-for="(marker, li) in data.markers" :key="'MARKER' + li" :ref="'cntMarker-' + li">
                    <h3 style="text-align: center;">Marker #{{li + 1}}</h3>
                    <div style="display: flex; align-items: center; text-align: center; flex-direction: column; flex: 100%;">
                        <Minimap :img="grayimg" :x="marker.position.x" :y="marker.position.y"></Minimap>
                        <span style="width: 100%;">
                            X: <input type="range" min="0" max="750" v-model="marker.position.x" style="width: 400px;">
                            <input type="text" v-model="marker.position.x" style="width: 40px;">
                        </span>
                        <span style="width: 100%;">
                            Y: <input type="range" min="0" max="550" v-model="marker.position.y" style="width: 400px;">
                            <input type="text" v-model="marker.position.y" style="width: 40px;">
                        </span>
                    </div>
                    <input type="text" v-model="marker.label" placeholder="Label">
                    <div><label>Color:</label><input type="color" v-model="marker.color"></div>
                    <div><input style="width: 100%;" placeholder="Title..." type="text" v-model="marker.description.title"></div>
                    <div><textarea style="width: 100%;" placeholder="Detailed description..." type="color" v-model="marker.description.detail"></textarea></div>
                    <button style="flex: 100%; background: red; color: white;" @click="deleteMarker(li)">Delete Label</button>
                </div>
                <button style="flex: 100%; margin: 1em;" @click="addNewMarker()">Add New Marker</button>
            </div>
            <div>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
import Minimap from './minimap.vue';

export default {
    name: "Infographic5AddEditComponent",
    props: ['ID'],
    components:{Minimap},
    data: () => ({
        isLoading: true,
        title: "",
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        data: {
            labels: [],
            markers: []
        },
        functions: undefined,
        grayimg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2NQmyf2HwADogHabTva1QAAAABJRU5ErkJggg==",

    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            //update
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.title = data.title;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;

                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "getObject", (thumbBuff) => {
                    this.thumbnail.data = thumbBuff.signedUrl;
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.data = data.data;
                        this.data.labels.forEach(l => {
                            let buffer = l.position.x;
                            l.position.y = l.position.x;
                            l.position.x = buffer;
                        });
                        this.data.markers.forEach(l => {
                            let buffer = l.position.x;
                            l.position.y = l.position.x;
                            l.position.x = buffer;
                        });
                        this.isLoading = false;
                    });
                });
            });
        }else{
            //Create New
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.isLoading = false;
                this.addNewLabel();
                this.addNewMarker();
            },(err) => {
                console.error(err);
            });
        }
    },
    methods: {
        changeThumb: function(){
            var reader = new FileReader();
            reader.onload = (e) => {
                this.thumbnail.data = e.target.result;
            }
            reader.readAsDataURL(this.$refs.imgsel.files[0]);
            this.thumbnail.file = this.$refs.imgsel.files[0];
        },
        addNewLabel: function(){
            this.data.labels.push({
                label: "",
                color: (Math.random() < 0.5) ? "#001179" : "#790000",
                position: {
                    x: 0,
                    y: 0
                }
            });
        },
        addNewMarker: function(){
            this.data.markers.push({
                label: "",
                color: (Math.random() < 0.5) ? "#001179" : "#790000",
                position: {
                    x: 0,
                    y: 0
                },
                description: {
                    title: "",
                    detail: ""
                }
            });
        },
        deleteLabel: function(i){
            let c = confirm("Are you sure you want to delete Label #" + (i+1));
            if(c){
                this.data.labels.splice(i, 1);
            }
        },
        deleteMarker: function(i){
            let c = confirm("Are you sure you want to delete Marker #" + (i+1));
            if(c){
                this.data.markers.splice(i, 1);
            }
        },
        submitThis(){
            if(this.id){
                this.updateThis();
                return null;
            }
            this.$refs.cntTitle.classList.remove("has-error");
            let hasError = false;
            if(this.title.trim() == ""){
                this.$refs.cntTitle.classList.add("has-error");
                hasError = true;
            }else this.$refs.cntTitle.classList.remove("has-error");

            if(this.ID){
                //something
            }else{
                if(this.thumbnail.file == undefined){
                    this.$refs.cntThumb.classList.add("has-error");
                    hasError = true;
                }else this.$refs.cntThumb.classList.remove("has-error");
            }
            
            this.data.labels.forEach((label, i) => {
                if(label.label.trim() == ""){
                    this.$refs["cntLabel-" + i][0].classList.add("has-error");
                    hasError = true;
                }else this.$refs["cntLabel-" + i][0].classList.remove("has-error");
            });
            
            this.data.markers.forEach((label, i) => {
                if(label.label.trim() == ""){
                    this.$refs["cntMarker-" + i][0].classList.add("has-error");
                    hasError = true;
                }else this.$refs["cntMarker-" + i][0].classList.remove("has-error");
            });

            if(hasError){
                console.log("HAS ERROR");
                return false;
            }
            this.isLoading = true;
            var componentData = {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "infographic5",
                Data: JSON.parse(JSON.stringify(this.data))
            };
            console.log(componentData);
            componentData.Data.labels.forEach(lbl => {
                let buffer = lbl.position.x;
                lbl.position.x = lbl.position.y;
                lbl.position.y = buffer;
            });
            componentData.Data.markers.forEach(lbl => {
                let buffer = lbl.position.x;
                lbl.position.x = lbl.position.y;
                lbl.position.y = buffer;
            });
            // console.log(componentData);return null;

            if(this.ID){
                if(this.thumbnail.file != undefined){
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        this.functions.updateComponent(this.ID, componentData,(dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/infographic5");
                        });
                    });
                }else{
                    this.functions.updateComponent(this.ID, componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic5");
                    });
                }
            }else{
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.functions.addComponent(componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic5");
                    });
                });
            }
        }
    }
};
</script>

<style scoped>
    hr{
        border: solid 2px white;
    }
    h2{
      color:black;
    }
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid !important;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>